import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=ef47cd44&scoped=true&"
import script from "./CommonButton.vue?vue&type=script&lang=js&"
export * from "./CommonButton.vue?vue&type=script&lang=js&"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=ef47cd44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef47cd44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
